import { useEffect, useState } from 'react';

const marqueeItems = [
  '54 PARTICIPANTS', 'AMITY UNIVERSITY GWALIOR', '3 DAYS',
  'JUSTICE INNOVATION 101', 'AWAAZ LEADERSHIP LABS', 'REAL DATA',
  '54 PARTICIPANTS', 'AMITY UNIVERSITY GWALIOR', '3 DAYS',
  'JUSTICE INNOVATION 101', 'AWAAZ LEADERSHIP LABS', 'REAL DATA',
];

export default function Hero() {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { setTimeout(() => setLoaded(true), 80); }, []);

  const t = (delay) => ({
    opacity: loaded ? 1 : 0,
    transform: loaded ? 'translateY(0)' : 'translateY(24px)',
    transition: `opacity 0.45s ease ${delay}s, transform 0.45s ease ${delay}s`,
  });

  return (
    <section id="hero" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#FFFFFF', position: 'relative', overflow: 'hidden' }}>

      {/* Grain texture */}
      <div style={{ position:'absolute', inset:0, opacity:0.04, pointerEvents:'none', backgroundImage:`url("data:image/svg+xml,%3Csvg viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")` }} />

      {/* Big teal block top-right — neo brutalist accent */}
      <div style={{ position:'absolute', top:0, right:0, width:'320px', height:'320px', background:'var(--accent)', border:'2.5px solid var(--black)', borderTop:'none', borderRight:'none', zIndex:0, opacity: loaded?1:0, transition:'opacity 0.6s ease 0.1s' }}>
        <div style={{ padding:'1.5rem', fontFamily:'var(--font-head)', fontSize:'0.65rem', fontWeight:700, letterSpacing:'0.15em', textTransform:'uppercase', color:'var(--black)' }}>
          Impact Report<br />2025
        </div>
      </div>

      {/* Main content */}
      <div className="container" style={{ flex:1, display:'flex', flexDirection:'column', justifyContent:'center', position:'relative', zIndex:1, paddingTop:'6rem', paddingBottom:'3rem' }}>

        {/* Tag */}
        <div style={t(0.1)}>
          <span className="tag tag-black" style={{ marginBottom:'2rem', display:'inline-block' }}>JI 101 × Awaaz Leadership Labs</span>
        </div>

        {/* Giant headline */}
        <h1 className="h1" style={{ ...t(0.2), marginBottom:'0.3rem' }}>
          Making<br />
          Justice<br />
          <span style={{ color:'var(--accent)', WebkitTextStroke:'2px var(--black)' }}>Cool.</span>
        </h1>

        <div style={{ ...t(0.3), marginTop:'2rem', marginBottom:'1rem' }}>
          <div className="divider-accent" />
        </div>

        <p className="body-lg" style={{ ...t(0.35), maxWidth:'480px', marginBottom:'2.5rem' }}>
          Here's the proof. In numbers, in data, in the words of 54 students who left this workshop seeing the world differently.
        </p>

        {/* 3 inline hero stats */}
        <div style={{ ...t(0.42), display:'flex', gap:'0', flexWrap:'wrap', marginBottom:'3rem' }}>
          {[
            { n:'54', label:'Participants' },
            { n:'3', label:'Days' },
            { n:'100%', label:'Would recommend' },
          ].map((s, i) => (
            <div key={i} style={{
              padding:'1rem 1.5rem',
              borderTop:'2.5px solid var(--black)',
              borderBottom:'2.5px solid var(--black)',
              borderLeft: i===0?'2.5px solid var(--black)':'none',
              borderRight:'2.5px solid var(--black)',
              background: i===1?'var(--black)':'var(--white)',
            }}>
              <div style={{ fontFamily:'var(--font-head)', fontSize:'1.8rem', fontWeight:700, color: i===1?'var(--accent)':'var(--black)', lineHeight:1 }}>{s.n}</div>
              <div style={{ fontFamily:'var(--font-head)', fontSize:'0.62rem', fontWeight:600, letterSpacing:'0.1em', textTransform:'uppercase', color: i===1?'var(--white)':'var(--muted)', marginTop:'4px' }}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* Scroll cue */}
        <div style={{ ...t(0.5), display:'flex', alignItems:'center', gap:'12px' }}>
          <div style={{ width:38, height:38, border:'2.5px solid var(--black)', borderRadius:0, display:'flex', alignItems:'center', justifyContent:'center', animation:'bounce 2s infinite' }}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M7 2v10M3 8l4 4 4-4" stroke="var(--black)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <span style={{ fontFamily:'var(--font-head)', fontSize:'0.65rem', fontWeight:700, letterSpacing:'0.15em', textTransform:'uppercase', color:'var(--muted)' }}>Scroll to explore the data</span>
        </div>
      </div>

      {/* Marquee strip */}
      <div style={{ borderTop:'2.5px solid var(--black)', borderBottom:'2.5px solid var(--accent)', background:'var(--accent)', overflow:'hidden', padding:'10px 0' }}>
        <div className="marquee-track">
          {marqueeItems.map((item, i) => (
            <span key={i} style={{ fontFamily:'var(--font-head)', fontSize:'0.7rem', fontWeight:700, letterSpacing:'0.2em', textTransform:'uppercase', color:'var(--black)', padding:'0 2.5rem', whiteSpace:'nowrap' }}>
              {item} <span style={{ opacity:0.5 }}>◆</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
